<script>
import PedalKnob from '../PedalKnob.vue';
import CcBadge from '../CcBadge.vue';

export default {
  components: { PedalKnob, CcBadge },
  data() {
    return {
      // Hard at 12 o'clock (index 0), Soft at 6 o'clock (index 1, opposite side)
      boundaryOptions: [
        { value: 'hard', label: 'Hard' },
        { value: 'soft', label: 'Soft' },
      ]
    }
  },
  props: {
    effect: {
      type: Object,
      required: true
    }
  }
}
</script>
<template>
  <div class="pedal-knobs">
    <CcBadge :effect="effect" param="min">
      <PedalKnob
        label="Min"
        tip="Minimum CC value the Wander effect can drift to."
        :value="effect.min ?? 0"
        @update:value="v => effect.min = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="max">
      <PedalKnob
        label="Max"
        tip="Maximum CC value the Wander effect can drift to."
        :value="effect.max ?? 127"
        @update:value="v => effect.max = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="step_size">
      <PedalKnob
        label="Step"
        tip="Maximum amount the CC value changes on each step. Small values produce gentle organic drift; large values produce more erratic movement."
        :min="1"
        :max="127"
        :value="effect.step_size ?? 10"
        @update:value="v => effect.step_size = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="boundary_mode">
      <PedalKnob
        label="Boundary"
        tip="Soft: probability of reversing direction increases near Min and Max for natural behaviour. Hard: value bounces immediately at the limits."
        mode="enum"
        variant="circular"
        :options="boundaryOptions"
        :value="effect.boundary_mode ?? 'hard'"
        @update:value="v => effect.boundary_mode = v"
        />
    </CcBadge>
  </div>
</template>
